import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useCurrentModal } from '../../../components/modals/ModalsContext'
import { useOpenEditLinktreeModal } from '../../../utils/routes/modals/modalsActions'
import Button from '../../../packages/kiti/components/actions/Button'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('listLinkTrees')
  const data = useCurrentModal()
  const openEditModal = useOpenEditLinktreeModal()

  return (
    <>
      <Grid justify="flex-start" align="center" gutter={0.3}>
        <Col flex={1}>
          <Title size="h4" color={COLORS.dark2} noMargin>
            {t('title')}
          </Title>
        </Col>

        <Col flex={1}></Col>

        <Col>
          <Button transparent onClick={() => openEditModal(data)} size="small">
            {t('newMenu')}
          </Button>
        </Col>
      </Grid>

      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
